

$( document ).ready(function() {

  $(window).scroll(function(){
  var sticky = $('.devHeadTrans'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass('devfixed');
  else sticky.removeClass('devfixed');
});
$('.list-menu--inline > li').each(function(){
    $(this).hover(
        function(){
          $('.devHeadTrans').addClass('devCursorEnt');
            $(this).find('details').attr('open','');
            $(this).find('summary').attr('aria-expanded','true')
        },
         function(){
           $('.devHeadTrans').removeClass('devCursorEnt');
            $(this).find('details').removeAttr('open','');
            $(this).find('summary').attr('aria-expanded','false')
         }
    )
})

  
  // Reviews Slider homepage
    $('.devReviewSlider').slick({
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          fade: true,
          adaptiveHeight: true,
          slidesToScroll: 1,
          prevArrow:"<img class='slick-prev' src='https://cdn.shopify.com/s/files/1/0689/3587/6904/files/Daco_5051380.png?v=1681142080'>",
          nextArrow:"<img class='slick-next' src='https://cdn.shopify.com/s/files/1/0689/3587/6904/files/clipart4645372.png?v=1681141334'>"
    });


    $(".devcontent").hide();
    $(".show_hide").on("click", function () {
        var txt = $(".devcontent").is(':visible') ? 'Read More' : 'Read Less';
        $(".show_hide").text(txt);
        $(this).next('.devcontent').slideToggle(200);
    });

    $('.devReadMore').on('click', function(){
      console.log('abc');
       $(this).parent().toggleClass('devShowContent');
      var replaceText = $(this).parent().hasClass("devShowContent") ? " Less " : " More ";
      $(this).text(replaceText);
      var devL = $(".devRichText p").val().length;
      console.log(devL);
      
    })


  // $('.readmore').insertAfter( '.product__description' );
  //              var curHeight = $('.product__description').height(); 
  //           $('.readmore').hide();
  //            if(curHeight >= 230){
  //                $('.readmore').show();
  //            }
  //            else{
  //                $('.readmore').hide();
  //            }
            
  //       $('.readmore').click(function (event) {
  //         event.preventDefault();
  //       var description = document.querySelector('.product__description');
          
  //         console.log(description.style.height)
  //         if (description.style.height === ''){
  //           description.style.height = 'auto';
  //         } else if (description.style.height === 'auto'){
  //           description.style.height = '';
  //         }
  //         else{
  //           description.style.height = '230px';
  //         }

  //         $(this).text($(this).text() == 'Less' ? 'More' : 'Less');
          
  //       });

           
       

 
});